import Layout from "../components/Layout";

const ReportsPage = (props: any) => {
    return (
        <Layout>
            <h1>Report Page</h1>
        </Layout>
    )
}

export default ReportsPage